export default __webpack_public_path__ + "static/media/Triangles_06.38bf33b4.png";